export default __webpack_public_path__ + "static/media/Sergi_Nogal_CV.04663262.pdf";